import {
  ControllerRenderProps,
  MultiSelectHierarchy,
  GroupOption,
} from '@otp/ui';
import { ResourceFolder } from 'src/graphql/generated/graphql';
import { useResourceFolders } from 'src/hooks/query/resources/use-folders';

type ResourceFolderFieldProps = {
  field: ControllerRenderProps<any, any>;
  className?: string;
  multiple?: boolean;
  error?: boolean;
};

function convertFoldersToNestedOptionsList(data: Partial<ResourceFolder>[]) {
  const map = data.reduce(
    (acc, item) => {
      acc[item.id as unknown as string] = {
        name: item.name || '',
        value: item.id,
        parentValue: item.parentId,
        children: [],
      };

      return acc;
    },
    {} as Record<string, GroupOption>,
  );

  return data.reduce((acc, item) => {
    if (item.parentId) {
      const parent = map[item.parentId];
      if (parent) {
        parent.children?.push(map[item.id]);
      } else {
        acc.push(map[item.id]);
      }
    } else {
      acc.push(map[item.id]);
    }
    return acc;
  }, [] as Array<GroupOption>);
}

export const ResourceFolderField = ({
  field,
  className,
  multiple = false,
  error,
}: ResourceFolderFieldProps) => {
  const { folders } = useResourceFolders({
    pagination: { limit: 200, page: 0 },
  });

  if (!folders.length) {
    return null;
  }

  const options = convertFoldersToNestedOptionsList(folders);

  return (
    <MultiSelectHierarchy
      multiple={multiple}
      key={field.value}
      fullWidth={true}
      className={className}
      options={options}
      defaultValue={field.value}
      {...field}
      value={undefined}
      ref={undefined}
      error={error}
    />
  );
};
